import { useState, useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";

const Banner = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch("https://api.mytimewatch.com/api/banners"); // Adjust for production API
        const files = await response.json();
        setBanners(files);
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    };

    fetchBanners();
  }, []);

  return (
    <div className="container-fluid p-0 d-flex align-items-center mt-5">
      <div className="w-100">
        <div
          id="carouselExample"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="2000"
          data-bs-pause="hover"
        >
          <div className="carousel-inner">
            {banners.map((file, index) => (
              <div key={file} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <img
                  src={`https://api.mytimewatch.com/banners/${file}`} // Dynamically fetch image
                  className="d-block w-100"
                  alt={file}
                  style={{ objectFit: "contain" }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
